import type { DogtagStore as DogtagStoreState } from './types';

import { ID } from './config';

export const clear = (): void => {
  console.log('Clear storage');
  localStorage.removeItem(ID);
};

export const saveToStorage = ({ account, clan }: DogtagStoreState): void => {
  try {
    const newStorateState: DogtagStoreState = {
      account,
      clan,
      ttl: new Date().getTime(),
    };

    localStorage.setItem(ID, JSON.stringify(newStorateState));
  } catch (error) {
    console.error('Cannot save local storage', error);
  }
};

export const loadFromStorage = (): DogtagStoreState | undefined => {
  let result: DogtagStoreState | undefined = undefined;
  try {
    const stringData = localStorage.getItem(ID);
    if (stringData) {
      result = JSON.parse(stringData) as DogtagStoreState;
    }
  } catch (error) {
    console.error('Cannot load from local storage', error);
    return result;
  }

  return result;
};
